import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("salestdpcr/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/salestdpcr/send2wfCancel/${obj.tdpcrkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'Advertiser', 'brand', 'customer', 'customer_id', 'paidtoname', 'nomor', 'sales_search', 'tgl1', 'tgl2', 'statuswf', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/salestdpcr${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    listae(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'Advertiser', 'brand', 'customer', 'customer_id', 'paidtoname', 'nomor', 'sales_search', 'tgl1', 'tgl2', 'statuswf', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/salestdpcr/byae${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("/salestdpcr", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    attachmentDownload(obj) {
        return new Promise((resolve, reject) => {
            try {
                axios({
                    url: `/salestdpcr/attachment/${obj.tdpcrkey}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', obj.attchFileNm);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/salestdpcr/detail/${obj.tdpcrkey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`salestdpcr/${obj.tdpcrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    } ,   
    print(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/salestdpcr/print?tdpcrkey=${obj.tdpcrkey}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'Advertiser', 'brand', 'customer', 'customer_id', 'paidtoname', 'nomor', 'sales_search', 'tgl1', 'tgl2', 'statuswf'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/salestdpcr/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'sales_tdp_CR_list.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    exportxlsae(obj) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'Advertiser', 'brand', 'customer', 'customer_id', 'paidtoname', 'nomor', 'sales_search', 'tgl1', 'tgl2', 'statuswf'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/salestdpcr/exportxlsae${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'sales_tdp_CR_list.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },

}